import script from "./lyredis.vue?vue&type=script&setup=true&lang=js"
export * from "./lyredis.vue?vue&type=script&setup=true&lang=js"

import "./lyredis.vue?vue&type=style&index=0&id=879bd2a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-879bd2a0"]])

export default __exports__